import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  fetchNotificationsFailed: false,
  unseenNotificationsCount: 0,
  unseenDetails: null,
  loading: false
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
